(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "react-router", "../StackRouter/matchPath", "../StackRouter/matchRoute", "./useLocationKey", "../constants"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("react-router"), require("../StackRouter/matchPath"), require("../StackRouter/matchRoute"), require("./useLocationKey"), require("../constants"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactRouter, global.matchPath, global.matchRoute, global.useLocationKey, global.constants);
    global.useViews = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _reactRouter, _matchPath, _matchRoute, _useLocationKey, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useViews = useViews;

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function useViews(routes, routerIndex) {
    var location = (0, _reactRouter.useLocation)();
    var history = (0, _reactRouter.useHistory)();
    var refLocation = (0, _react.useRef)(null);
    var refRoutes = (0, _react.useRef)(routes);

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        views = _useState2[0],
        setViews = _useState2[1];

    var findIndex = (0, _react.useCallback)(function (location, views) {
      if (!location) return null;
      var key = (0, _useLocationKey.getLocationKey)(location, routerIndex);
      return views.findIndex(function (view) {
        return view.key === key;
      });
    }, [routerIndex]);
    (0, _react.useLayoutEffect)(function () {
      var routes = refRoutes.current;
      var HISTORY_MAX_LENGTH = window.history.length || 50;
      var matchedRoute = (0, _matchRoute.matchRoute)(location.pathname, routes);
      if (!matchedRoute) return;
      var prevLocation = refLocation.current;
      var key = (0, _useLocationKey.getLocationKey)(location, routerIndex);
      var match = (0, _matchPath.matchPath)(location.pathname, matchedRoute.props);
      var nextView = {
        key: key,
        route: matchedRoute,
        match: _objectSpread(_objectSpread({}, match), {}, {
          key: key
        })
      };
      setViews(function (views) {
        var prevViewIndex = findIndex(prevLocation, views);
        var nextViewIndex = findIndex(location, views);

        if ((prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.pathname) === location.pathname && (prevLocation === null || prevLocation === void 0 ? void 0 : prevLocation.hash) !== location.hash) {// do nothing.
        } else if (nextViewIndex > -1 && !routerIndex) {
          if (history.action === _constants.PUSH) {
            views.splice(0, nextViewIndex);
          } // do nothing.

        } else if (nextViewIndex > -1 && routerIndex) {
          views.splice(nextViewIndex, 1, nextView);
        } else if (history.action === _constants.PUSH || history.action === _constants.REPLACE) {
          if (refLocation.current && prevViewIndex > -1) {
            if (history.action === _constants.PUSH) {
              views.splice(0, prevViewIndex, nextView);
            } else if (history.action === _constants.REPLACE) {
              views.splice(prevViewIndex, 1, nextView);
            }
          } else if (routerIndex) {
            views = [nextView];
          } else {
            views.unshift(nextView);
          }
        } else if (history.action === _constants.POP && !history.direction) {
          views.unshift(nextView);
        } else if (history.action === _constants.POP && history.direction) {
          if (history.direction === _constants.BACKWARD) {
            views.push(nextView);
          } else {
            views.unshift(nextView);
          }
        }

        return _toConsumableArray(views).splice(0, HISTORY_MAX_LENGTH);
      });
    }, [history, location, routerIndex, findIndex]); // To prevent 'useLayoutEffect' execution by updated 'routes'

    (0, _react.useEffect)(function () {
      refRoutes.current = routes;
    }, [routes]);
    (0, _react.useEffect)(function () {
      refLocation.current = location;
    }, [location]);
    return {
      views: views,
      setViews: setViews
    };
  }
});